import React, {useRef, useState, useEffect} from 'react'
import './panel.css'
import firebase from '../../config/fbConfig.js'
import PanelWorkers from './panelWorkers';
import PanelAdmin from './panelAdmin';
import {Helmet} from "react-helmet";

const auth = firebase.auth();

function Panel(props) {
    const email = useRef()
    const password = useRef()
    const showPassElem = useRef()
    const [user, setUser] = useState(null)
	const isPhone = useRef(false)
    const [error, setError] = useState({isUser: false, nothingEntered: false, wrongDetails: false})
    const [isAdmin, setIsAdmin] = useState()
    
    useEffect(() => {

        isPhone.current = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        auth.onAuthStateChanged(user => {
            if (user) {     
                if (props.history.location.pathname.includes("/panel")) {
                    if (user.isAnonymous) { // if logged as anonymous then log out
                        auth.signOut();
                    } else {                    
                        isAdminOrWorker(user);
                        setUser(user); 
                    }
                }
            } else {
                setUser(false);
                if (!isPhone.current) email.current.focus();
                let obj = localStorage.getItem('panel');
                if (obj!==null) {
                    obj = JSON.parse(obj);
                    email.current.value = obj.email;
                    password.current.value = obj.pass;
                }
            }
        })
    }, [])
    //let workersList = ['worker@gmail.com'];
    let adminsList = ['admin@gmail.com', 'demoadmin@gmail.com'];
    let isAdminOrWorker = (user) => {
        let index = adminsList.findIndex(i => i === user.email);
        // -1 means It's not an admin, hence it must be worker
        if (index === -1) {
            setIsAdmin(false);
        } else {
            setIsAdmin(true);
        }
    }

    let DeOptimizeCart = (arr) => {
        let DeOptimizeExtras = (extras) => {
            if (extras==null) return null;
            let newArr = [];
            let obj = {};
            for (let i = 0; i < extras.length; i++) {
                obj.name = extras[i].n;
                obj.price = extras[i].p;
                newArr.push(obj);
                obj = {};
            }
            return newArr;
        }

        let newArr = [];
        let obj = {};
        for (let i = 0; i < arr.length; i++) {
            obj.name = arr[i].n;
            obj.price = arr[i].p;
            obj.totalPrice = arr[i].t;
            obj.options = arr[i].o != null ? arr[i].o : null;
            obj.extras = DeOptimizeExtras(arr[i].e);
            newArr.push(obj);
            obj = {};
        }
        return newArr;
    }
    
    let DeOptimizeObject = (obj) => {
        let x = {
            service:      obj.s,
            restaurant:   obj.r,
            chosenTime:   obj.x, // because this is the 1 before last letter and easy to remember
            state:        obj.z, // because this is the last letter and most important to remember
            fullName:     obj.n,
            phoneNum:     obj.q,
            address:      obj.a,
            timestamp:    obj.t,
            cart:      DeOptimizeCart(obj.c),
            totalPrice:   obj.p,
            key: obj.key,
            id: obj.i
        };
        return x;
    }
    
    let getNameState = (state) => {
        if (window.location.href.includes('/en')) {
            if (state==0) return "PENDING"
            if (state==1) return "DENIED"
            if (state==2) return "ACCEPTED"
            if (state==3) return "ACCEPTED" // with delay
        } else {
            if (state==0) return "ממתין לאישור"
            if (state==1) return "נדחה"
            if (state==2) return "התקבלה בהצלחה"
            if (state==3) return "התקבלה בהצלחה" // with delay
        }
    }

    let getNameService = (service) => {
        if (window.location.href.includes('/en')) {
            if (service==1) return "Takeaway"
            if (service==2) return "Delivery"
            if (service==3) return "Table Reserveation"
        } else {
            if (service==1) return "טייק-אווי"
            if (service==2) return "משלוח"
            if (service==3) return "שולחן מוכן"
        }  
    }
    
    let getStyleState = (state) => {
        if (state==0) return { color: 'rgb(170, 0, 0)' }
        if (state==1) return { color: 'red' }
        if (state==2 || state == 3) return { color: 'green' }
    }

    let getDateFormat = (timestamp) => {
        let dateFormat = new Date(timestamp*1000);
        let firstPart = dateFormat.toLocaleDateString("en-GB");
        let hours = "";
        let minutes = "";

        if (dateFormat.getHours()<10) {
            hours = "0" + dateFormat.getHours();
        } else { hours = dateFormat.getHours();	}

        if (dateFormat.getMinutes()<10) {
            minutes = "0" + dateFormat.getMinutes();
        } else { minutes = dateFormat.getMinutes();	}

        return `${firstPart} <br/> ${hours}:${minutes}`;
    }


    
    let signIn = (e) => {
        e.preventDefault();
        const emailAddress = email.current.value;
        const pass = password.current.value;

        auth.signInWithEmailAndPassword(emailAddress, pass).then(cred => {
            
            localStorage.setItem('panel', JSON.stringify({
                email: emailAddress,
                pass: pass
            }))
            if (window.location.href.includes('/en')) { 
                alert('Successfully signed in!');
            } else {
                alert('התחברת בהצלחה!');
            }
            
        })
        .catch(err => {
            if (err.code=='auth/user-not-found') {
                setError({isUser: true, nothingEntered: false, wrongDetails: false})
                return;
            }
            if (emailAddress == "" || pass == "") {
                setError({isUser: false, nothingEntered: true, wrongDetails: false})
            } else {
                setError({isUser: false, nothingEntered: false, wrongDetails: true})
            }
        });
        
    }

    // When ticking the checkbox, showing the password
	let showPass = (value) => {
		if (value.checked) {
			password.current.type="text";
		} else {
			password.current.type="password";
		}
    };
    // Onload
    if (user===null) return null;
    // If it is a Hebrew page, so render it in English
    if (window.location.href.includes('/en')) {
        if (user===false) {
            return (
                <div id="panelForm">
                    <Helmet>
                        <title>Dashboard | Itay's Restaurant</title>
                        <meta 
                        name="description" 
                        content="Dashboard for Workers and Admins ! Itay's Restaurant (© Itay Shiff)" />
                        <meta name="robots" content="unindex, unfollow"/>
                    </Helmet>

                    <form>
                        <div>Login Page To Panel</div>
                        <label htmlFor="email">Email Address</label>
                        <input type="text" id="email" ref={email}/>
                        
                        <label htmlFor="password">Password</label>
                        <input type="password" id="password" ref={password}/>
                        
        
                        <input type="checkbox" id="showPass" ref={showPassElem} onClick={() => showPass(showPassElem.current)}/><span style={{fontSize: '23px'}}>Show Password</span>
        
                        {error.isUser && 
                        <div id="err">Sorry, this account doesn't exist.</div>}
                        {error.nothingEntered && <div id="err">Sorry, you didn't enter anything, what'd you expect huh?</div>}
                        {error.wrongDetails && <div id="err">You entered wrong password/email.</div>}
        
                        <button onClick={signIn}>Connect</button>
                    </form>
                </div>
            )
        } else { // When the user logged in  
            return (
                <div id="panel">          
                    {!isAdmin ? 
                    <PanelWorkers user={user} setUser={setUser} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameService={getNameService} getNameState={getNameState} getStyleState={getStyleState} getDateFormat={getDateFormat}/>
                    :
                    <PanelAdmin user={user} setUser={setUser} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameService={getNameService} getNameState={getNameState} getStyleState={getStyleState} getDateFormat={getDateFormat}/>}
                </div>
            )
        }   
    }

    // Else render it in Hebrew
    // When the user isn't logged in
    if (user===false) {
        return (
            <div id="panelForm" className="hebrew">
                <Helmet>
                    <title>ניהול המערכת | המסעדה של איתי</title>
                    <meta 
                    name="description" 
                    content="ניהול המערכת לעובדים ולמנהלים ! המסעדה של איתי שיף ©" />
                    <meta name="robots" content="unindex, unfollow"/>
                </Helmet>

                <form>
                    <div>התחברות למערכת</div>
                    <label htmlFor="email">כתובת אימייל</label>
                    <input type="text" id="email" ref={email}/>
                    
                    <label htmlFor="password">סיסמה</label>
                    <input type="password" id="password" ref={password}/>
                    
    
                    <input type="checkbox" id="showPass" ref={showPassElem} onClick={() => showPass(showPassElem.current)}/><span style={{fontSize: '23px'}}>הראה סיסמה</span>
    
                    {error.isUser && 
                    <div id="err">המשתמש שהכנסת לא קיים.</div>}
                    {error.nothingEntered && <div id="err">אי אפשר להמשיך בלי למלא כלום</div>}
                    {error.wrongDetails && <div id="err">הכנסת פרטים שגויים</div>}
    
                    <button onClick={signIn}>כניסה</button>
                </form>
            </div>
        )
    } else { // When the user logged in
        return (
            <div id="panel" className="hebrew">

                {!isAdmin ? 
                <PanelWorkers user={user} setUser={setUser} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameService={getNameService} getNameState={getNameState} getStyleState={getStyleState} getDateFormat={getDateFormat}/>
                :
                <PanelAdmin user={user} setUser={setUser} DeOptimizeCart={DeOptimizeCart} DeOptimizeObject={DeOptimizeObject} getNameService={getNameService} getNameState={getNameState} getStyleState={getStyleState} getDateFormat={getDateFormat}/>}
            </div>
        )
    }
}

export default Panel
